const autoFormatNumber = (number: number): string => {
  if (!Number.isInteger(number)) {
    return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return number.toLocaleString();
};
export default autoFormatNumber;
